

var dashboard = function() {
	$('body.authentication').height($(window).height());
};

jQuery(document).ready(function($){
	dashboard();
	$('#screen-loader').fadeOut(200, function(){
		$(this).remove();
	});
	// $('.ui.dropdown').dropdown({
	// 	on : 'hover'
	// });
	// $('.ui.checkbox').checkbox();
});
